export enum OrderStatusEnum {
  UNKNOWN = "unknown",
  PENDING = "pending",
  APPROVED_BY_SELLER = "approved-by-seller",
  CANCELED_BY_SELLER = "canceled-by-seller",
  CANCELED_BY_BUYER = "canceled-by-buyer",
}
